<template>
    <div class="culture">

     <img
      src="../../assets/culture/benner.png"
      alt
      style="width: 100%; height: 22.5rem ;overflow:hidden; object-fit: cover;"
    />
    <h3>{{msg}}</h3>
     <div class="actives">
        <el-row :gutter="30">
        <el-col  v-for="(item, index) in actives" :key="index" :span="12">
        <div style="min-height: 31.75rem;">
        <img
          :src="item.icon"
          alt
          style="width: 18.75rem; height: 18.75rem;"/>
        <span style="font-size:1.5rem;line-height:1.75rem;font-weight: 600;text-align: center;display: block;margin-bottom: .9375rem;margin-top:1.875rem ;">{{ item.title }}</span>
        <!-- <div v-html="item.desc" style="font-size:1.5rem;line-height:2.25rem;color: #777777;margin-bottom: 1.875rem; min-height: 4rem;"></div>   -->
        </div>
        </el-col>
        </el-row>

        </div>
    </div>
</template>
<style scoped>
.culture{
  min-height: 100%;
}
h3 {
  padding-top: 4.375rem;
  padding-bottom:4.375rem;
  color: #1A1A1A;
  font-size: 2.25rem;
}

.actives{
    width:84%;
    display: inline-block;
    margin-bottom: 4.375rem;
}
</style>

<script>
export default {

    data () {
    return {
     msg: '企业文化',
     actives:[
     {
       icon:require('../../assets/culture/icon01.png'),
       title:'效率',
       desc:'快速前进<br/>打破一切'
     },
     {
       icon:require('../../assets/culture/icon02.png'),
       title:'质量',
       desc:'刻苦钻研<br/>精益求精'
     },
     {
       icon:require('../../assets/culture/icon03.png'),
       title:'业务',
       desc:'以用户为中心<br/>拒绝伪需求'
     },
     {
       icon:require('../../assets/culture/icon04.png'),
       title:'诚信',
       desc:'说到做到'
     },
     {
       icon:require('../../assets/culture/icon05.png'),
       title:'自信',
       desc:'不小看自己<br/>人有无限可能'
     },
     {
       icon:require('../../assets/culture/icon06.png'),
       title:'学习',
       desc:'学习是一种生活方式'
     },
     {
       icon:require('../../assets/culture/icon07.png'),
       title:'沟通',
       desc:'缜密思维<br/>阳光沟通'
     },
     {
       icon:require('../../assets/culture/icon08.png'),
       title:'团结',
       desc:'精诚合作<br/>携手共进'
     },]
    };
    },
    onActivated (){

    }
}
</script>



// WEBPACK FOOTER //
// src/components/mobile/Culture.vue